import { render } from "./ProfileConfig.vue?vue&type=template&id=db542528&scoped=true"
import script from "./ProfileConfig.vue?vue&type=script&lang=js"
export * from "./ProfileConfig.vue?vue&type=script&lang=js"

import "./ProfileConfig.vue?vue&type=style&index=0&id=db542528&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db542528"]])

export default __exports__